
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class PasswordChangedDialog extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    value!: boolean;
}
